import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import Checkbox from "../../input/Checkbox";

const EmpathyServices = () => {
    const empathyLink = 'https://join.empathy.com/principal-digital-intake'

    return (
        <QuestionPanel headerText={"Do you want to receive personalized beneficiary support?"}
                       detailsText={<div className="flex-gap">
                               <div>Not available with group policies issued in New York.</div>
                           <div>
                               The value-added resources provided through Empathy are not a part of any insurance products and plan
                               administrative services provided through Principal Life Insurance Company® or affiliated with any company of
                               the Principal Financial Group®. All resources may be changed or canceled at any time.
                           </div>
                           <div>
                               The use of resources provided by Empathy should not be considered a substitute for consultation with an
                               attorney or advisor. Principal® is not responsible for any loss, injury, claim, liability, or damages
                               related to the use of the Empathy resources.
                           </div>
                           <div>
                               If you want specific advice regarding your situation, consult an attorney or advisor.
                               Information is intended to be educational in nature and is not intended to be taken as a recommendation.
                           </div>
                       </div>}
                       panelContent={
                           <div className="flex-gap">
                               <label>
                                   Empathy is a complimentary bereavement care benefit for Principal beneficiaries, providing practical and emotional support after a loss.
                                   Principal will share your name, phone number, and email address with Empathy. If you prefer not to be contacted by Empathy, please check the box below.
                               </label>
                               <Checkbox id="opt-out-of-empathy"
                                         label="I do not want Empathy to contact me about my bereavement care benefit.">
                               </Checkbox>
                               <label>
                                   To get started right away, <a
                                   href={empathyLink} target="_blank" rel="noopener noreferrer">register here</a>.
                               </label>
                           </div>
                       }>
        </QuestionPanel>
    )
};
export default EmpathyServices;